
export default class Archives{
    
    constructor() {
        this.$self = null;
        this._init();
    }


    _init(){

        if(document.location.hostname == "localhost"){
            this.COUNTER_API = '/chu5/mvweb_2023/assets/json/good.json';
        }
        else{
            this.COUNTER_API = 'https://library.benesse.ne.jp/bbsui/uiservice/';
        }
        //console.log(this.COUNTER_API);

        this.items = [...document.querySelectorAll('.archives__item')];

        this.btnCnt = 'BtnCnt1';
        this.likes = this._getGoodStorage();
        this._connect();

        this._checkNew();
    }


    /**
     * New マーク
     */
    _checkNew(){

        [...document.querySelectorAll('.archives__item')].forEach($item=>{
            const fromDate = new Date($item.getAttribute('data-entrydate'));
            const toDate = new Date();
            const ms = toDate.getTime() - fromDate.getTime();
            const days = Math.floor(ms / (1000*60*60*24));
            
            if(days <= 14){
                $item.querySelector('.archives__new').classList.add('-active');
            }
        });
    }

    
    /**
     * イイねボタン
     */
    _connect(){
        const send = {CmtSelect: [{ ThmId:'count_mvw', DspStrtLoc:1, DspLin: 9999}]};
        const jsonData = {json: JSON.stringify(send)};

        $.ajax({
            url: this.COUNTER_API,
            type: 'POST',
            data: jsonData,
            dataType: 'json',
            success: (data)=>{
                this._onSuccess(data);
            },
            error:()=>{
            },
        });
    }

    _onSuccess(data){

        this.items.forEach($item=>{
            const blogId = $item.getAttribute('id');
            const cmtId = $item.getAttribute('data-goodid');
            const counter = {};

            if(!cmtId){
                $item.querySelector('.archives__good__count').innerHTML = 0;
                return;
            }

            // 該当のCmtIdを持つコメントを取得
            counter.count = 0;
            data.CmtSelect[0].CmtList.some(elm => {
            
                if(elm.CmtId == cmtId){
                    counter.count = elm[this.btnCnt];
    
                    let _Cmt = JSON.parse(elm.Cmt);
                    counter.adjustment = _Cmt[this.btnCnt].adjustment;
                    return true;
                }
            });

            // 増減が設定されていたら反映
            if(counter.adjustment){
                counter.count += parseInt(counter.adjustment);
            }

            $item.querySelector('.archives__good__count').innerHTML = counter.count;

            // イイね済みか
            if(this._checkAlreadyGood(blogId)){
                $item.querySelector('.js-archives-good').classList.add('-active');
            }
        });
    }

    _getGoodStorage(){
        return parent.window.DATA.getData('likes');
    }

    _checkAlreadyGood(blogId){
        if(this.likes.indexOf(blogId) > -1) return true;
        return false;
    }
}